<template>
  <div>
   <!-- <v-row fill-height align="center" justify="center" style="margin:0">
      <span v-if="ListUser.length < 0">Tidak Ada Data</span>
    </v-row> -->
        <v-card elevation="3" class="mx-2 my-2">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.nama }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.nama_ho }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <!-- <v-list-item-action-text v-text="item.id"></v-list-item-action-text> -->
              <v-list-item-action-text v-if="item.id_mst_user_type == 2">
                <span style="color: red">{{ item.user_type }}</span>
              </v-list-item-action-text>
              <v-list-item-action-text v-else>
                <span style="color: teal">{{ item.user_type }}</span>
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>

          <!-- <v-img v-if="item.photo != null" :src="$url_img + item.photo" height="194"></v-img>
          <v-img v-else src="https://img.icons8.com/clouds/2x/user.png" height="194"></v-img> -->
          <v-list-item>
            <v-list-item-content>
               <v-list-item-subtitle>Id User : {{ item.id }}</v-list-item-subtitle>
              <v-list-item-subtitle>No. Hp : {{ item.nomor_hp }}</v-list-item-subtitle>
              <v-list-item-subtitle>Email : {{ item.email }}</v-list-item-subtitle>
              <v-list-item-subtitle>Status : {{ item.user_status }}</v-list-item-subtitle>
           
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <!-- <v-btn text color="deep-purple accent-4">
                Bookmark
            </v-btn>-->
            <v-spacer></v-spacer>
         
            <v-btn text @click="onDetail(item.id)">Detail</v-btn>
          </v-card-actions>
        </v-card>
      <!-- </v-col>
    </v-row> -->
  </div>
</template>

<script>
export default {
  name: 'ListUser',
  props: ["item", "onDetail"],
  data() {
    return {};
  },
  methods: {}
};
</script>
